/* eslint-disable import/no-unresolved */
import '@services/index.js';

require('@app/javascripts/utilities/utilities.js');

$(() => $('html').trigger('consumer.dependencies.loaded'));
